module.exports = __webpack_public_path__ + "img/timeline_miscevent-11.7402ef01.jpg";